<template>
  <div class="page-edit">
    <back url="/mng/sharedData">
      共享数据设置
    </back>
    <h2 class="content-title">
      {{ ruleId ? '修改规则' : '新建规则' }}
    </h2>
    <div v-spinner="pageLoading" class="page-edit-box">
      <v-spinner :opacity="0.5" size="large" />
      <form-title title="基础信息" style="margin-bottom: 28px;" />
      <rule-name-input ref="ruleNameInput" v-model="ruleName" @submit="onSubmit" />
      <v-form kind="desc">
        <v-form-item name="business" label="共享的数据范围" required="共享的数据范围">
          <div>
            <business-select :selected="businessId" @loading="onBusinessLoadingChange" @change="onBusinessChange" />
          </div>
        </v-form-item>
        <div v-if="hasBusinessData" v-spinner="businessLoaing">
          <v-spinner :opacity="0.5" size="large" />
          <form-title title="规则条件" style="margin-bottom: 28px;" />
          <v-form-item label="数据权限范围" name="rule">
            <business-rule-select ref="ruleSelect" :key="ruleKey" :rule-options="ruleList" :rule-info="showRuleInfo"
              @change="onRuleChange"
/>
          </v-form-item>
          <v-form-item label="操作权限范围" name="option">
            <opt-check-list :options="optList" :checked-list="checkedOptList" @change="onOptChange" />
          </v-form-item>
        </div>
        <form-title title="后续动作" style="margin-bottom: 28px;" />
        <v-form-item label="被共享人" required="被共享人" name="share">
          <share-item-list :options="shareList" @change="onShareChange" />
        </v-form-item>
      </v-form>
      <div class="button-section">
        <v-button :loading="saveLoading" status="primary" kind="primary" @click="saveClick">
          保存
        </v-button>
        <v-button status="default" @click="cancelClick">
          取消
        </v-button>
      </div>
    </div>
  </div>
</template>

<script>
import Back from '@/components/back';
import RuleNameInput from '@/pages/mng/permission/dataRule/components/rule-name-input';
import BusinessSelect from '@/pages/mng/permission/dataRule/components/business-select';
import BusinessRuleSelect from '@/pages/mng/permission/dataRule/components/business-rule-select';
import ShareItemList from '@/pages/mng/permission/dataRule/components/share-item-list';
import OptCheckList from '@/pages/mng/permission/dataRule/components/opt-check-list';
import FormTitle from '@/components/form-title';

export default {
  components: {
    Back,
    RuleNameInput,
    BusinessSelect,
    BusinessRuleSelect,
    ShareItemList,
    OptCheckList,
    FormTitle,
  },
  data() {
    return {
      pageLoading: false,
      ruleName: '',
      hasBusinessData: false,
      businessLoaing: false,
      businessId: '',
      optList: [],
      checkedOptList: [],
      ruleList: [],
      ruleKey: 'rk',
      shareList: [],
      saveLoading: false,
      ruleInfo: {},
      ruleId: this.$route.params.ruleId,
      showRuleInfo: {},
      editMode: false,
      refreshList: false,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.refreshList) {
      // 设置下一个路由的 meta
      to.meta.refresh = true; // 让列表页刷新列表
    } else {
      to.meta.refresh = false;
    }

    this.isChange = false;

    next();
  },

  created() {
    if (this.ruleId) {
      this.ruleId = parseInt(this.ruleId, 10);
      this.getRuleData();
    }
  },

  mounted() { },

  methods: {
    getRuleData() {
      this.$ajax
        .gatewayPost('/v1/sharedPrivilege/sharedRule', {
          rule_id: this.ruleId,
        })
        .then((data) => {
          const { rule } = data.data || {};
          const { name, owners, ops, showData, bo_id: boId } = rule || {};
          this.ruleName = name;
          this.shareList = owners;
          this.businessId = boId;
          this.checkedOptList = ops;
          this.showRuleInfo = {
            showData: JSON.parse(showData),
          };
          this.editMode = true;
        });
    },

    onBusinessLoadingChange(val) {
      this.businessLoaing = val;
    },

    onBusinessChange(res) {
      const { id, data } = res || {};
      const { optList, checkedOptList, ruleList } = data || {};

      this.businessId = id;
      this.optList = optList || [];
      this.ruleList = ruleList || [];
      this.hasBusinessData = true;

      if (!this.editMode) {
        this.checkedOptList = checkedOptList || [];
        this.showRuleInfo = {
          showData: {
            children: [],
          },
        };
      }

      this.editMode = false;

      this.ruleKey = `rk${Date.now()}`;
    },

    onOptChange(data) {
      this.checkedOptList = data;
    },

    onRuleChange(ruleInfo) {
      this.ruleInfo = ruleInfo;
    },

    onShareChange(list) {
      this.shareList = list;
    },

    ruleValidate() {
      this.$refs.ruleSelect.validate().then((res) => {
        if (!res) {
          this.$message.error('请将条件填写完整后再进行保存。');
          return;
        }
        if (res) {
          this.saveReq();
        }
      });
    },

    onSubmit(e) {
      e.preventDefault();

      if (!this.businessId) {
        this.$message.error('请选择业务类型');
      } else if (this.checkedOptList.length <= 0) {
        this.$message.error('请勾选操作权限范围');
      } else if (this.shareList.length <= 0) {
        this.$message.error('请选择被共享人');
      } else {
        this.ruleValidate();
      }
    },

    saveClick() {
      this.$refs.ruleNameInput.formSubmit();
    },

    saveReq() {
      const { ruleData, showData } = this.ruleInfo || {};
      const reqRule = {
        bo_id: Array.isArray(this.businessId) ? this.businessId[this.businessId.length - 1] : this.businessId,
        name: this.ruleName,
        ruleData: JSON.stringify(ruleData),
        showData: JSON.stringify(showData),
        ops: this.checkedOptList,
        owners: this.formatShareReqData(this.shareList),
      };

      let reqUrl = '/v1/sharedPrivilege/addSharedRule';

      if (this.ruleId) {
        reqUrl = '/v1/sharedPrivilege/updateSharedRule';
        reqRule.rule_id = this.ruleId;
      }

      this.$ajax
        .gatewayPost(reqUrl, {
          rule: reqRule,
        })
        .then(() => {
          this.$message.success('保存成功', () => {
            this.refreshList = true;
            this.$router.push('/mng/sharedData');
          });
        })
        .catch((msg) => {
          this.$message.error(msg.message || '保存失败');
        });
    },

    cancelClick() {
      this.$router.push('/mng/sharedData');
    },

    formatShareReqData(list) {
      return list.map((item) => {
        const { id, type } = item || {};
        return {
          id,
          type,
        };
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import './index.less';
</style>
